import instance from "@/services/api";

export const openSpaceLinksAPI = {
  async getList(params) {
    return await instance()
      .get("/project/floor_map/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorMapLinks(floor_map_id, params) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/openspace/read/`, { params })
      .then((res) => res?.data);
  },
  async addLink(body, params) {
    return await instance()
      .post(`/project/floor_map/openspaces/add/`, body, { params })
      .then((res) => res?.data);
  },
  async deleteFloorMapLink(floor_map_id, openspace_id, params) {
    return await instance()
      .delete(
        `/project/floor_map/${floor_map_id}/openspaces/${openspace_id}/delete/`,
        {
          params,
        }
      )
      .then((res) => res?.data);
  },
};
